import React, { useEffect, useState } from "react";
import { Button, ButtonSize, ButtonVariant } from "@wattpad/web-ui-library";

import { useTrans, useGetUser } from "../../hooks";
import getTaxonomyReviewStories from "../../../helpers/client.get-taxonomy-review-stories";

const WriterReivewBanner = () => {
  const { trans } = useTrans();
  const user = useGetUser();
  const [hasStoriesToReview, setHasStoriesToReview] = useState(false);

  useEffect(
    () => {
      getTaxonomyReviewStories(user?.username).then(data => {
        if (data.stories.length > 0) {
          setHasStoriesToReview(true);
        }
      });
    },
    [user]
  );

  if (!hasStoriesToReview) {
    return null;
  }

  return (
    <div className="writer-review-container">
      <span className="typography-paragraph-medium">
        {trans(
          "Add a story type to help readers find your story. In the upcoming weeks, we'll assign a story type to stories still missing one."
        )}
      </span>
      <div className="review-buttons">
        <Button
          variant={ButtonVariant.PRIMARY}
          label={trans("Review stories")}
          size={ButtonSize.SMALL}
          ariaLabel={trans("Review stories")}
          href={`/write/stories/review`}
        />
        <Button
          variant={ButtonVariant.SECONDARY}
          size={ButtonSize.SMALL}
          label={trans("Learn more")}
          ariaLabel={trans("Learn more")}
          href={`https://docs.google.com/document/d/1Nv-YEQzH0pwwIs-U5wuHx3kFft_UWJJFV2U36fLZ09c/edit?tab=t.0`}
          isExternalLink
        />
      </div>
    </div>
  );
};

export default WriterReivewBanner;
